<template>
  <div id="map" class="full-screen-map"></div>
</template>
<script>
import { API_KEY } from "./API_KEY";
import firebase from '../../Firebase';
import { Loader, LoaderOptions } from "google-maps";

const loader = new Loader(API_KEY);

export default {
  data() {
    return {
      nav: null,
     // tableData:[]
    };
  },
  mounted() {
    let nav = document.getElementsByTagName('nav');
    if (nav.length > 0) {
      this.nav = nav[0];
    }
    this.nav.classList.add('fixed-top');
    this.nav.classList.remove('navbar-transparent');
    loader.load().then(function(google) {


    
      const myLatlng = new google.maps.LatLng(29.712153, -82.354548);
      const mapOptions = {
        zoom: 11,
        center: myLatlng,
        scrollwheel: true, // we disable de scroll over the map, it is a really annoing when you scroll through page
        disableDefaultUI: true, // a way to quickly hide all controls
        zoomControl: true,
        styles: [
          {
            elementType: 'geometry',
            stylers: [
              {
                color: '#1d2c4d'
              }
            ]
          },
          {
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#8ec3b9'
              }
            ]
          },
          {
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#1a3646'
              }
            ]
          },
          {
            featureType: 'administrative.country',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#4b6878'
              }
            ]
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#64779e'
              }
            ]
          },
          {
            featureType: 'administrative.province',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#4b6878'
              }
            ]
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#334e87'
              }
            ]
          },
          {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [
              {
                color: '#023e58'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#283d6a'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#6f9ba5'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#1d2c4d'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#023e58'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#3C7680'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
              {
                color: '#304a7d'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#98a5be'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#1d2c4d'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
              {
                color: '#2c6675'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#9d2a80'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#9d2a80'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#b0d5ce'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#023e58'
              }
            ]
          },
          {
            featureType: 'transit',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#98a5be'
              }
            ]
          },
          {
            featureType: 'transit',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#1d2c4d'
              }
            ]
          },
          {
            featureType: 'transit.line',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#283d6a'
              }
            ]
          },
          {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [
              {
                color: '#3a4762'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#0e1626'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#4e6d70'
              }
            ]
          }
        ]
      };

      const map = new google.maps.Map(
        document.getElementById("map"),
        mapOptions
      );

       firebase.firestore().collection("users").where("lat",">","")
        .get()
        .then((doc) => {
          
      doc.docs.forEach(note => {
  
  console.log(note.id, " => ", note.data().lat);

   const myLatlng= new google.maps.LatLng(note.data().lat, note.data().lng);



      const marker = new google.maps.Marker({
        position: myLatlng,
        title: note.data().firstName
      });

      const infowindow = new google.maps.InfoWindow({
    content: `<p style='color:black;'>${note.data().firstName} ${note.data().lastName} </p><p style='color:black;'><a href='https://app.martinsonmachine.com/meters/${note.data().meter[0]}' target='_blank'>Meter</a> </p>`,
  });

google.maps.event.addListener(marker, "click",  () => {
    infowindow.open(map, marker);
  });



  marker.setMap(map);

 // tableData.push(note.data())


      });

           
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });

      const myLatlng1 = new google.maps.LatLng(29.656087, -82.342134);



      const marker = new google.maps.Marker({
        position: myLatlng,
        title: "Regular Map!"
      });

       const marker1 = new google.maps.Marker({
        position: myLatlng1,
        title: "Regular 1!"
      });

// google.maps.event.addListener(marker1, "click",  () => {
//     infowindow.open(map, marker);
//   });
// marker.setMap(map);
// const infowindow = new google.maps.InfoWindow({
//     content: "<p style='color:black;'><a href='https://www.freecodecamp.org/'>HERE</a> </p>",
//   });


//   google.maps.event.addListener(marker, "click",  () => {
//    // await 
// //     console.log("Hello");
// //  const date = Date.now();
// //   let currentDate = null;
// //   do {
// //     currentDate = Date.now();
// //   } while (currentDate - date < 2000);

// // console.log("Goodbye!");
//     infowindow.open(map, marker);
//   });
  
     

  



      // marker.setMap(map);
      // marker1.setMap(map);
    });
  },

methods:{
sleep(milliseconds) {
  const date = Date.now();
  let currentDate = null;
  do {
    currentDate = Date.now();
  } while (currentDate - date < milliseconds);
}
,
 timeout(ms) {
   
    return new Promise(resolve => setTimeout(resolve, ms));
}
},


  beforeDestroy() {
    this.nav.classList.add('navbar-transparent');
    this.nav.classList.remove('bg-white');
    this.nav.classList.remove('fixed-top');
  }
};
</script>
<style>
#map {
  height: 100vh;
}
</style>
